var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"white-button",style:(_vm.style)},[_c('vs-button',{class:{
      'primary': _vm.$props.textColor === 'primary',
      'purple': _vm.$props.textColor === 'purple',
      'green': _vm.$props.textColor === 'green'
    },attrs:{"icon":_vm.$props.isIcon,"size":_vm.$props.size}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }